export const isOdd = (n: number): boolean => n % 2 === 1
